
import { i18nText } from '@/locales';
import {checkUserRole} from '@/router/Lib/helper';
import Api from '@/repository/api';

import {Component, Prop, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import SalonGeneralFormComponent from "@/UI/components/forms/Studios/SalonGeneralForm.vue";
import StudioTransfer from "@/UI/pages/salons/components/StudioTransfer.vue";
import {mixins} from "vue-class-component";
import moment from "moment";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import {ProxyTableData} from "@/UI/components/Helpers/ProxyTableData";
import {SalonForm, FormRules, FormGroupRules} from "@/UI/pages/salons/lib/SalonForm"
import {TerritoryStore} from "@/store/modules/Territory";
import {CurrencyStore} from "@/store/modules/Currency";
import {ManagerStore} from "@/store/modules/Manager";
import {GroupsStore} from "@/store/modules/Groups";
import {ScrollData, SearchData} from "@/UI/Decorators/decorator";
import {GroupFormData} from "@/form/Studios/Studio";
import {Col, DatePicker, FormModel, Input, message, Modal, notification, Row, Select, TimePicker} from "ant-design-vue";
import EDateTimePicker from "@/UI/components/EDateTimePicker/EDateTimePicker.vue";

@Component({
    components: {
        SalonGeneralFormComponent,
        PageTitle,
        FormGroup,
        StudioTransfer,
        CreateFormSalon,
        "a-select": Select,
        "a-select-option": Select.Option,
        "a-row": Row,
        "a-col": Col,
        "a-input": Input,
        "a-form-model": FormModel,
        "a-form-model-item": FormModel.Item,
        "a-date-picker": DatePicker,
        "a-modal": Modal,
        'a-time-range-picker': TimePicker,
        "e-datetimepicker": EDateTimePicker,
        "v-nodes": {
            functional: true,
            render: (h: any, ctx: any) => ctx.props.vnodes,
        },
    },
    methods: {moment, checkUserRole}
})

export default class CreateFormSalon extends mixins(
    ProxyTableData,
) {
    @Prop() readonly form!: SalonForm
    companies: any[] = [];
    showModal: boolean = false
    rules = FormRules
    groupRules = FormGroupRules
    formGroup = new GroupFormData();
    checkRole: boolean = false
    route = Vue.router.currentRoute.name

    mounted() {
        // ----- activity legacy conversion and default value setting (https://topit.bitrix24.ru/workgroups/group/147/tasks/task/view/4821/?any=group%2F147%2Ftasks%2Ftask%2Fview%2F4821%2F&MID=22405#com22405) (Starting line.) -----
        // // ----- legacy values conversion (Starting line.) -----
        // if (this.form.active === 1 || this.form.active === "1") {
        //     this.form.active = true;
        // }
        // else if (this.form.active === 0 || this.form.active === "0") {
        //     this.form.active = false;
        // }
        // // ----- legacy values conversion (Ending line.) -----

        // ----- set default form activity value (Starting line.) -----
        // @ts-ignore
        if (this.form.active !== true || this.form.active !== false) {
            //this.form.active = true;
        }
        // ----- set default form activity value (Ending line.) -----
        // ----- activity legacy conversion and default value setting (https://topit.bitrix24.ru/workgroups/group/147/tasks/task/view/4821/?any=group%2F147%2Ftasks%2Ftask%2Fview%2F4821%2F&MID=22405#com22405) (Ending line.) -----

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        //this.form.active = !!this.form.active;
    }

    console() {
        console.clear()
        console.log(this.form.conclusion_contract_date)
    }

    workTimeFrom(value: any) {
        this.form.work_time_from = value ? moment(value, 'HH:mm') as any : null;
    }

    getPopupContainer(): any {
        return document.querySelector('main');
    }

    workTimeTo(value: any) {
        this.form.work_time_to = value ? moment(value, 'HH:mm') as any : null;
    }

    replaceMail(value: any) {
        this.form.partner_email = this.form.partner_email.toString().replace(/[^0-9a-zA-Z@.]/gm, '');
        console.clear()
        // this.form.partner_email = value.target.value.replace(-'', '@')
    }

    replacePartnerPhone(value: any) {
        this.form.partner_phone = value.target.value.replaceAll(/[a-zA-Z]/g, '');
        if(Number(value.target.value)) {
            this.form.partner_phone = value.target.value.substr(0, 19)
        }
    }

    replacePhone(value: any) {
        this.form.phone = value.target.value.replaceAll(/[a-zA-Z]/g, '');
        if(Number(value.target.value)) {
            this.form.phone = value.target.value.substr(0, 19)
        }
    }

    handleOpeningDateChange(value: any): void {
        this.form.conclusion_contract_date = new Date(value["_d"]).toLocaleDateString("ru-RU");
    }

    handleCCDateChange(value: any): void {
        this.form.opening_date = new Date(value["_d"]).toLocaleDateString("ru-RU");
    }

    async onGroupSubmit(): Promise<void> {

        (this.$refs.createGroup as FormModel).validate(async (valid) => {

            if (valid) {
                try {
                    GroupsStore.create(this.formGroup);
                    message.info(i18nText("Группа добавлена"));
                    this.showModal = false;
                } catch (e) {
                    message.error(i18nText("Ошибка операции -") + e);
                    this.showModal = false;
                } finally {
                    await this.fetchModule([{s: 'groups'}])
                }
            }
        });
    }

    async created(): Promise<void> {
        try {
            this.checkRole = Vue.auth.check("admin");
            if (!this.form.id && checkUserRole() === 'admin') this.companies = (await Api.get('/company/get')).data.data;
        } catch (e) {
            console.error(e)
        }
    }

    addGroup(): void {
        this.showModal = true
    }

    handleCancel(): void {
        this.showModal = false
    }

    get territory() {
        return TerritoryStore.cities?.data
    }

    get currency() {
        return CurrencyStore.currency
    }

    get manager() {
        return ManagerStore.manager
    }

    get groups() {
        return GroupsStore.groups
    }

    @SearchData
    HSearch(source: string, value: any) {
    }

    @ScrollData
    HScroll(source: string) {
    }

    handleSearchManager(val: any) {
        if(!val.length || val.length === 0) console.log("R", this.route)
        this.HSearch('manager', {name: val})
    }

    handleScrollManager() {
        this.HScroll('manager')
    }

    handleSearchTerritory(val: any) {
        this.HSearch('territory', {name: val})
    }
}
